// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactForm } from "@keller/App/Services/ContactUsService";

type SubmitContactFormParameter = {
    name?: string;
    emailAddress?: string;
    phone?: string;
    contactMeBy?: string;
    message?: string;
    locationName?: string;
    useShowroomEmail?: boolean;
};

interface Props {
    apiResult: any;
    apiParameter: any;
    error?: string;
}

type Parameter = SubmitContactFormParameter & HasOnSuccess & HasOnError<string>;

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await submitContactForm(props.apiParameter);
    } catch (error) {
        props.error = error.errorMessage;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const submitContactUsForm = createHandlerChainRunner(chain, "SubmitContactUsForm");
export default submitContactUsForm;
